import Vue from 'vue'
import Router from 'vue-router'
import HelpCenter from '@/components/HelpCenter'
import Help from '@/components/Help'
import Service from '@/components/Service'
import VersionLog from '@/components/VersionLog'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'HelpCenter',
      component: HelpCenter
    },
    {
      path: '/help',
      name: 'HelpCenter',
      component: HelpCenter
    },
    {
      path: '/help/:name',
      name: 'Help',
      component: Help
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/version',
      name: 'VersionLog',
      component: VersionLog
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js